/**
 *
 * VideoCall
 *
 */

/* eslint-disable no-restricted-globals */

import React from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { Device } from "components";
import MenuBar from "./components/MenuBar";

import Strings from "utils/strings";
import "./styles.scss";

class Call extends React.Component<any, any> {
	boundsTimeout: any | undefined;
	timeoutMenu: any | undefined;

	constructor(props: any) {
		super(props);

		this.state = {
			mobile: document.body.getBoundingClientRect()?.width <= 480 || false
		};

		this.handleResize = this.handleResize.bind(this);
		this.handleMouseMove = this.handleMouseMove.bind(this);
		this.handleResize();
	}

	componentDidMount() {
		window.addEventListener("resize", this.handleResize);
		window.addEventListener("orientationchange", this.handleResize);
		window.addEventListener("mousemove", this.handleMouseMove);
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.handleResize);
		window.removeEventListener("orientationchange", this.handleResize);
		window.removeEventListener("mousemove", this.handleMouseMove);
	}

	handleResize() {
		// @ts-ignore
		const orientation = (screen?.orientation || {}).type || screen?.mozOrientation || screen?.msOrientation;
		this.boundsTimeout = setTimeout(
			() =>
				this.setState({
					mobile:
						document.body.getBoundingClientRect()?.width <= 480 ||
						orientation === "portrait-primary" ||
						orientation === "portrait-secondary"
				}),
			200
		);
	}

	handleMouseMove(e: any) {
		const { openAudioCallModal } = this.props;
		const { mobile } = this.state;

		if (openAudioCallModal && !mobile) {
			const path = e.path || (e.composedPath && e.composedPath());

			const inside = path.some((path: any) => path.className === "AudioCallContainer");

			if (inside) {
				const elems = document.getElementsByClassName("AudioMenuBar");
				if (elems) {
					for (const elem of elems) {
						elem.classList.add("--menu-visible");
					}
				}
			}

			clearTimeout(this.timeoutMenu);
			this.timeoutMenu = setTimeout(() => {
				const elems = document.getElementsByClassName("AudioMenuBar");
				if (elems) {
					for (const elem of elems) {
						elem.classList.remove("--menu-visible");
					}
				}
			}, 1000);
		}
	}

	render() {
		const { openAudioCallModal, totalParticipants, audioSettings, dispatch } = this.props;
		const { mobile, showMobileOverlay } = this.state;

		if (!openAudioCallModal) return null;

		return (
			<div className="AudioCallContainer">
				<Device>
					<div className="ScreenBlur" />
					<div
						onClick={() => {
							if (mobile) {
								this.setState(
									(prevState: any) => ({ showMobileOverlay: !prevState.showMobileOverlay }),
									() => {
										clearTimeout(this.timeoutMenu);
										this.timeoutMenu = setTimeout(() => {
											this.setState({ showMobileOverlay: false });
										}, 5000);
									}
								);
							}
						}}
						className={`ScreenContent${showMobileOverlay ? " __mobileOverlay" : ""}`}
					>
						<div className="AudioMediaContainer">
							<div ref="remoteMedia" id="remote-media" />
						</div>
						<div className="AudioButtonsContainer">
							<MenuBar showMobileOverlay={showMobileOverlay} mobile={mobile} />
						</div>
						<div className="AudioCallContent">
							{totalParticipants === 0 ? (
								<div className="AudioCallPatient">
									<p>{Strings.home.noPatientOnCall}</p>
								</div>
							) : (
								<div className="AudioCallPatient">
									<div className="AudioCallPatientAvatar">
										{Boolean(audioSettings?.user?.photo) ? (
											<img
												onClick={() => dispatch(push(`/patients/${audioSettings?.user?._id}`))}
												src={audioSettings?.user?.photo}
												alt="patient avatar"
											/>
										) : (
											<p onClick={() => dispatch(push(`/patients/${audioSettings?.user?._id}`))}>
												{audioSettings?.user?.name?.substring(0, 1)}
											</p>
										)}
									</div>
									<p onClick={() => dispatch(push(`/patients/${audioSettings?.user?._id}`))}>
										{audioSettings?.user?.name}
									</p>
								</div>
							)}
						</div>
					</div>
				</Device>
			</div>
		);
	}
}

const mapStateToProps = (state: any) => ({
	audioRoom: state.audioRoom,
	audioSettings: state.audioSettings
});

export default connect(mapStateToProps)(Call);
